import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertTo24Hour',
  standalone: true 
})
export class ConvertTo24HourPipe implements PipeTransform {

  transform(time: string | null | undefined): string {
    if (!time) return '';

    // Case 1: already HH:mm:ss
    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
      return time;
    }

    // Case 2: HH:mm → HH:mm:00
    if (/^\d{2}:\d{2}$/.test(time)) {
      return `${time}:00`;
    }

    // Case 3: "hh:mm AM/PM" or "hh:mm:ss AM/PM"
    const parts = time.split(' ');
    if (parts.length === 2) {
      const [timePart, modifier] = parts;
      let [hours, minutes, seconds = '00'] = timePart.split(':');

      let h = Number(hours);
      const m = Number(minutes);
      const s = Number(seconds);

      if (modifier === 'PM' && h < 12) h += 12;
      if (modifier === 'AM' && h === 12) h = 0;

      return `${h.toString().padStart(2, '0')}:${m
        .toString()
        .padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }

    return '';
  }
}
